import { render, staticRenderFns } from "./Contact4.vue?vue&type=template&id=394a8f84&scoped=true&"
import script from "./Contact4.vue?vue&type=script&lang=js&"
export * from "./Contact4.vue?vue&type=script&lang=js&"
import style0 from "./Contact4.vue?vue&type=style&index=0&id=394a8f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a8f84",
  null
  
)

export default component.exports